// libs
import { create } from 'zustand';
// constants
import { INITIAL_STATE } from './constants';
const useReadCampaignStore = create((set, get) => (Object.assign(Object.assign({}, structuredClone(INITIAL_STATE)), { setCampaign: (campaign) => set({ campaign: structuredClone(campaign) }), setError: (error) => set({ error }), setLoading: (loading) => set({ loading }), clear: () => set(Object.assign({}, structuredClone(INITIAL_STATE))) })));
export default useReadCampaignStore;
